import React from 'react';
import { NpcPortrait } from '../../components/NpcPortrait';
import { TomeTitleBlock } from '../../primitives/tome';

interface NpcPanelHeaderProps {
  npcId?: string;
  npcType?: string;
  name: string;
  subtitle: string;
  onClose?: () => void;
  closeLabel?: string;
  /** Portrait pose while the panel is open; Pip and Mallow have talk/gesture variants. */
  pose?: 'talk' | 'gesture';
}

/**
 * The NPC as a tome title block: the portrait is a slot (its art is authored
 * elsewhere and never restyled here), the role line and name sit beside it.
 */
export const NpcTitleBlock: React.FC<NpcPanelHeaderProps & { aside?: React.ReactNode }> = ({
  npcId, npcType, name, subtitle, aside, onClose, closeLabel = 'Close', pose = 'talk',
}) => <TomeTitleBlock portrait={<NpcPortrait npcId={npcId} npcType={npcType} name={name} size={88} pose={pose} />}
  eyebrow={subtitle} title={name} aside={aside} onClose={onClose} closeLabel={closeLabel} />;
